import React, { useState } from "react";
import {useFirebase} from "react-redux-firebase";
import {GoogleAuthProvider, signInWithPopup} from "firebase/auth"
import {Button, Input, Form, Alert} from "antd";
import {GoogleOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {auth} from "../store";
import "./Login.css"

export const Login = () => {
    const [form] = Form.useForm();
    const [isRegister, setIsRegister] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const firebase = useFirebase();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const user = useSelector((state) => state.firebase);

    React.useEffect(() => {
        if (user.auth.isLoaded && user.auth.isEmpty === false) {
            const hash = window.location.hash;
            const urlParams = new URLSearchParams(hash.split('?')[1]);
            const redirect = urlParams.get('redirect');
            if (redirect) {
                navigate(redirect)
            } else {
                navigate('/spaces')
            }
        }
    }, [navigate, user]);

    const handleSubmit = async (values) => {
        setLoading(true);
        setError(null);
        try {
            if (isRegister) {
                await firebase.auth().createUserWithEmailAndPassword(values.email, values.password);
            } else {
                await firebase.auth().signInWithEmailAndPassword(values.email, values.password);
            }
        } catch (e) {
            setError(e.message);
            setLoading(false);
        }
    };

    const handleGoogleLogin = async () => {
        setLoading(true);
        setError(null);
        try {
            const provider = new GoogleAuthProvider();
            const result = await signInWithPopup(auth, provider);
            dispatch({
                type: 'LOGIN_USER_SUCCESS',
                payload: result
            })
            navigate("/spaces");
        } catch (e) {
            setError(e.message);
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-header">
                    <h1>Avocados</h1>
                </div>

                {error && (
                    <Alert
                        message={error}
                        type="error"
                        showIcon
                        closable
                        onClose={() => setError(null)}
                        style={{marginBottom: 24}}
                    />
                )}

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                >
                    <Form.Item
                        name="email"
                        rules={[
                            {required: true, message: 'Email is required'},
                            {type: 'email', message: 'Please enter a valid email'}
                        ]}
                    >
                        <Input
                            type="email"
                            placeholder="Email"
                            size="large"
                            disabled={loading}
                            variant="borderless"
                            className="auth-input"
                        />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[
                            {required: true, message: 'Password is required'},
                            ...(isRegister ? [{
                                validator: (_, value) => {
                                    if (!value || value.length >= 6) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Password must be at least 6 characters'));
                                }
                            }] : [])
                        ]}
                    >
                        <Input.Password
                            placeholder="Password"
                            size="large"
                            disabled={loading}
                            variant="borderless"
                            className="auth-input"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            size="large"
                            loading={loading}
                            className="auth-submit-btn"
                        >
                            {isRegister ? 'Create Account' : 'Sign In'}
                        </Button>
                    </Form.Item>
                </Form>

                <div className="auth-divider"></div>

                <Button
                    onClick={handleGoogleLogin}
                    block
                    size="large"
                    icon={<GoogleOutlined />}
                    loading={loading}
                    className="auth-google-btn"
                >
                    Continue with Google
                </Button>

                <div className="auth-toggle">
                    {isRegister ? (
                        <>
                            Have an account? <button onClick={() => setIsRegister(false)} className="auth-toggle-btn">Sign In</button>
                        </>
                    ) : (
                        <>
                            No account? <button onClick={() => setIsRegister(true)} className="auth-toggle-btn">Register</button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
